export default __webpack_public_path__ + "static/media/relative-bold-pro.d0539900.woff2";